import { render, staticRenderFns } from "./m-change-record-modal.vue?vue&type=template&id=067aa5c6&scoped=true&"
import script from "./m-change-record-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-change-record-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-change-record-modal.vue?vue&type=style&index=0&id=067aa5c6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067aa5c6",
  null
  
)

export default component.exports